// Making this an export in case future links are updated
// only need to update this link; component stays same

export const resumeLink = [
    {
        id: 1, 
        url: "https://drive.google.com/file/d/1N0VvKMKcAfogYAo-3gB3YONRT540EPLr/view?usp=sharing"
    }
]; 